import type { IUserRepository, SearchParams } from "@src/domain/users/repository/user.repository.interface";
import type { PaginatedUsersDTO } from "../dto/user.dto";
import { UserDtoMapper } from "../mappers/user-dto.mapper";

/**
 * Use Case: Search Users
 * Searches users with filters and pagination (Admin only)
 */
export class SearchUsersUseCase {
    constructor(private readonly userRepository: IUserRepository) { }

    /**
     * Execute the use case
     * @param params - Search and pagination parameters
     * @returns Promise<PaginatedUsersDTO> - Paginated list of users
     */
    async execute(params?: SearchParams): Promise<PaginatedUsersDTO> {
        const result = await this.userRepository.search(params);

        return {
            users: UserDtoMapper.toListItemDTOs(result.items),
            total: result.total,
            page: result.page,
            page_size: result.page_size,
            total_pages: result.total_pages,
            hasMore: result.hasMore,
        };
    }
}